import React from "react";
import { PrismicRichText } from "@prismicio/react";

const HERO_DESCRIPTION_CLASS =
    "!text-base sm:!text-2xl font-medium mt-4 font-poppins text-Text_White ";
const NewHeroDescription = ({ text, customStyles }) => {
    return (
        <PrismicRichText
            field={text}
            components={{
                heading1: ({ children }) => (
                    <p className={HERO_DESCRIPTION_CLASS + customStyles}>
                        {children}
                    </p>
                ),
                paragraph: ({ children }) => (
                    <p className={HERO_DESCRIPTION_CLASS + customStyles}>
                        {children}
                    </p>
                ),
            }}
        ></PrismicRichText>
    );
};

export default NewHeroDescription;
